import COM from './Block';


export default COM;


// WEBPACK FOOTER //
// ./src/js/components/Block/index.js